<template>
    <div v-if="loaded">
        <!-- Inline -->
        <div class="row q-mb-md">
            <!-- Filters hide/show button -->
            <div class="col-6">
                <div class="row" style="justify-content: flex-start">
                    <div>
                      <q-btn
                        @click="showFilters();"
                        :text-color="hideFilters ? 'grey-5' : 'white'"
                        class="neutral-btn ctrl-button btn-compact"
                        :class="{ primary: !hideFilters }"
                        icon="filter_list"
                        :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                      />
                    </div>
                    <!-- General searchfield -->
                    <div class="q-ml-md" style="flex-grow: 1">
                        <q-input
                            color="grey-5"
                            v-model="searchTerm"
                            @input="applyFilters"
                            :placeholder="
                                getString('module.emails.list.filter.label')
                            "
                        />
                    </div>
                </div>
            </div>
            <!-- Add button -->
            <div class="col-6" style="justify-content: flex-end">
                <q-btn
                    v-if="
                        $store.state.meStore.me.rights.includes(
                            `${permission}.add`
                        )
                    "
                    class="capitalize ctrl-button right"
                    color="ctrl-turquoise"
                    :label="getString('action.add')"
                    @click="$router.push(`/${module}/add`)"
                    icon-right="add"
                />
                <q-btn
                    v-if="
                        $store.state.meStore.me.rights.includes(
                            `${permission}.delete`
                        )
                    "
                    class="capitalize ctrl-button bg-ctrl-grey right q-mr-md"
                    color="ctrl-turquoise"
                    :disabled="!rowSelection.length"
                    :label="
                        $store.state.stringsStore.strings.list.actions.label
                    "
                    :class="{ 'button-active': rowSelection.length }"
                >
                    <q-icon size="large" name="mdi-chevron-down" />
                    <i v-show="rowSelection.length" class="counter">{{
                        rowSelection.length
                    }}</i>
                    <!-- Direct child of target -->
                    <q-popover anchor="bottom middle" self="top middle">
                        <q-list link>
                            <q-item
                                :class="{ disabled: !rowSelection.length }"
                                class="toolbar-list-item"
                                @click.native="removeRows('emails')"
                            >
                                <q-icon
                                    color="positive"
                                    size="large"
                                    name="delete"
                                />
                                {{
                                    $store.state.stringsStore.strings.action
                                        .remove
                                }}
                            </q-item>
                        </q-list>
                    </q-popover>
                </q-btn>
            </div>
        </div>

        <!-- Filters block -->
        <transition name="fade">
        <div v-if="!hideFilters" class="table-block q-mb-md">
          <div class="row q-pa-md" style="justify-content: space-between;">
            <!-- Select field -->
            <div class="col-6 q-pa-md">
              <q-select
                multiple
                @input="applyFilters"
                v-model="filters.category_id"
                :options="mappedCategories"
                :float-label="getString('category')"/>
            </div>
          </div>
          <div class="row q-pa-md" style="justify-content: space-between;">
            <div class="q-pa-md" style="vertical-align: middle;">
              <q-btn
                :disable="!activeFilters"
                @click="resetFilters()"
                class="capitalize ctrl-button"
                :color="activeFilters ? 'primary' : 'grey-4'"
                label="Reset"
              />
            </div>
          </div>
        </div>
        </transition>
        <!-- Data table -->
        <table-overview
            :endpoint="endpoint"
            :responseFormat="module"
            :columns="columns"
            :join="categories"
            :permission="permission"
            :module="module"
            :useStoreFilters="false"
            :selectable="selectable"
        >
        </table-overview>
    </div>
</template>

<script>
import EventBus from '@/event-bus';
import TableOverview from '@/components/overview/TableOverview.vue';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

export default {
  mixins: [
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      loaded: false,
      categories: [],
      rowSelection: [],
      module: 'emails',
      endpoint: 'emails',
      permission: 'emails',
      selectable: true,
      isLoading: false,
      searchTerm: '',
      columns: [
        {
          name: 'code',
          title: this.$store.state.stringsStore.language === 'en' ? 'Type' : 'Soort',
          sortField: 'code',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
          callback: code => this.getString(`module.emails.code.${code}`),
        },
        {
          name: 'subject',
          title: this.$store.state.stringsStore.language === 'en' ? 'Subject' : 'Onderwerp',
          sortField: 'subject',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: '__slot:email-category',
          title: this.getString(null, 'Category', 'Categorie'),
          sortField: 'category',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
        {
          name: '__slot:sending-enabled',
          title: this.getString(null, 'Active', 'Actief'),
          sortField: 'sending_enabled',
          titleClass: 'text-center sortable vcol-xs',
          dataClass: 'text-center vcol-xs',
        },
      ],
      filters: {
        category_id: []
      },
      hideFilters: true,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  computed: {
    mappedCategories() {
      return this.categories.map((category) => ({ label: category.name, value: category.id }));
    },
  },
  methods: {
    getString,

    removeRows(key) {
      EventBus.$emit('row-selection:delete', key);
    },
  },

  mounted() {
    // Before mounting, load the categories
    this.axios.get('emails/category?autocomplete=').then((res) => {
      this.categories = res.data.email_categories;
    }).finally(() => this.loaded = true);
    EventBus.$on('row-selection:update', (payload) => {
      this.rowSelection = payload;
    });
  },
  destroyed() {
    EventBus.$off('row-selection:update');
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
